import { DevicesState, DevicesActionTypes, devicesActionNames } from './types';

const initialState: DevicesState = {
  selectedDevice: undefined,
  checkInDetails: undefined,
  messageTransmissionDetails: undefined,
  suspendedDevice: false,
  restrictedDevice: false,
  homingService: {
    proposedRoute: undefined,
    page: undefined,
    error: undefined,
    option: undefined,
    isDeviceNotPresent: false,
  },
};

export const devicesReducer = (
  state: DevicesState = initialState,
  action: DevicesActionTypes,
): DevicesState => {
  switch (action.type) {
    case devicesActionNames.SET_DEVICE: {
      return {
        ...state,
        selectedDevice: action.payload,
      };
    }
    case devicesActionNames.SET_CHECK_IN_DETAILS: {
      return {
        ...state,
        checkInDetails: action.payload,
      };
    }
    case devicesActionNames.SET_MESSAGE_TRANSMISSION_DETAILS: {
      return {
        ...state,
        messageTransmissionDetails: action.payload,
      };
    }
    case devicesActionNames.CLEAR_MESSAGE_TRANSMISSION_DETAILS: {
      return {
        ...state,
        messageTransmissionDetails: {
          ...action.payload,
          lastTransmissionTime: {
            http: '',
            saber: '',
            mqtt: '',
            sbd_saber: '',
          },
        },
      };
    }
    case devicesActionNames.SET_IS_SUSPENDED_DEVICE: {
      return {
        ...state,
        suspendedDevice: action.payload,
      };
    }
    case devicesActionNames.SET_IS_RESTRICTED_DEVICE: {
      return {
        ...state,
        restrictedDevice: action.payload,
      };
    }
    case devicesActionNames.SET_HOMING_SERVICE_RESPONSE: {
      return {
        ...state,
        homingService: action.payload,
      };
    }
    default:
      return state;
  }
};
